import { createSelector } from 'reselect'

export const getIsMobile = createSelector(
  state => state.page_details.device_data.screen_width,
  screen_width => screen_width && screen_width <= 768
)





// WEBPACK FOOTER //
// ./src/data/redux/page_details/selectors.js